import { render } from "./BridgeFacts.vue?vue&type=template&id=3448cc1c"
import script from "./BridgeFacts.vue?vue&type=script&lang=js"
export * from "./BridgeFacts.vue?vue&type=script&lang=js"

import "./BridgeFacts.vue?vue&type=style&index=0&id=3448cc1c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__